"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gindex_1 = require("./gindex");
const node_1 = require("./node");
const zeroNode_1 = require("./zeroNode");
const ERR_INVALID_TREE = "Invalid tree";
class Tree {
    constructor(node, hook) {
        this._node = node;
        this.hook = hook;
    }
    get rootNode() {
        return this._node;
    }
    set rootNode(n) {
        this._node = n;
        if (this.hook) {
            this.hook(this);
        }
    }
    get root() {
        return this.rootNode.root;
    }
    getNode(index) {
        let node = this.rootNode;
        for (const i of gindex_1.gindexIterator(index)) {
            if (i) {
                if (node.isLeaf())
                    throw new Error(ERR_INVALID_TREE);
                node = node.right;
            }
            else {
                if (node.isLeaf())
                    throw new Error(ERR_INVALID_TREE);
                node = node.left;
            }
        }
        return node;
    }
    setter(index, expand = false) {
        let link = node_1.identity;
        let node = this.rootNode;
        const iterator = gindex_1.gindexIterator(index);
        for (const i of iterator) {
            if (i) {
                if (node.isLeaf()) {
                    if (!expand)
                        throw new Error(ERR_INVALID_TREE);
                    else {
                        const child = zeroNode_1.zeroNode(iterator.remainingBitLength() - 1);
                        node = new node_1.BranchNode(child, child);
                    }
                }
                link = node_1.compose(node.rebindRight.bind(node), link);
                node = node.right;
            }
            else {
                if (node.isLeaf()) {
                    if (!expand)
                        throw new Error(ERR_INVALID_TREE);
                    else {
                        const child = zeroNode_1.zeroNode(iterator.remainingBitLength() - 1);
                        node = new node_1.BranchNode(child, child);
                    }
                }
                link = node_1.compose(node.rebindLeft.bind(node), link);
                node = node.left;
            }
        }
        return node_1.compose(node_1.identity, link);
    }
    setNode(index, n, expand = false) {
        this.rootNode = this.setter(index, expand)(n);
    }
    getRoot(index) {
        return this.getNode(index).root;
    }
    setRoot(index, root, expand = false) {
        this.setNode(index, new node_1.LeafNode(root), expand);
    }
    getSubtree(index) {
        return new Tree(this.getNode(index), (v) => this.setNode(index, v.rootNode));
    }
    setSubtree(index, v, expand = false) {
        this.setNode(index, v.rootNode, expand);
    }
    clone() {
        return new Tree(this.rootNode);
    }
    getSingleProof(index) {
        const proof = [];
        let node = this.rootNode;
        for (const i of gindex_1.gindexIterator(index)) {
            if (i) {
                if (node.isLeaf())
                    throw new Error(ERR_INVALID_TREE);
                proof.push(node.left.root);
                node = node.right;
            }
            else {
                if (node.isLeaf())
                    throw new Error(ERR_INVALID_TREE);
                proof.push(node.right.root);
                node = node.left;
            }
        }
        return proof.reverse();
    }
}
exports.Tree = Tree;
